import { questionTypeMap, shuffleMap } from "./defMap";
import { shuffleObjectArray } from "../utils";

const hasRelationConf = (data) => {
  let itemTitleConfig = data?.relationConf;
  let isEmptyObject = Object.keys(itemTitleConfig)?.length === 0;
  let hasRelationList = !isEmptyObject
    ? itemTitleConfig?.list?.length > 0
    : false;
  return itemTitleConfig && hasRelationList;
};
// 批量处理所有题目选项随机情况
export const handleQuestionList = (questionList) => {
  const newQuestionList = [];
  questionList.forEach((question, index) => {
    let titleConfig = question.titleConfig;
    let questionType = questionTypeMap[titleConfig.type];
    let randConf = shuffleMap[titleConfig.randConf];
    let answerConfig = Object.values(question.answerConfig)[0];
    if (hasRelationConf(titleConfig)) {
      titleConfig.hasRelationConf = true; // 关联题目
      titleConfig.relationActive = false; // 是否激活
    }
    if (questionType === "singleChoose") {
      answerConfig = shuffleObjectArray(answerConfig, randConf);
    }
    if (questionType === "multipleChoose") {
      answerConfig.list = shuffleObjectArray(answerConfig.list, randConf);
    }
    if (questionType === "matrixSingle" || questionType === "matrixProgress") {
      answerConfig.rowTitleArray = shuffleObjectArray(
        answerConfig.rowTitleArray,
        randConf
      );
    }
    newQuestionList.push({
      questionIndex: index,
      titleConfig,
      answerConfig,
    });
  });
  return newQuestionList;
};
